<template>
  <div>
    <el-dialog
      width="800px"
      :title="'Редактирование группы' + ' ' + group.name"
      :visible.sync="dialogVisible"
      :before-close="closeDialog"
    >
      <el-transfer
        v-if="loaded"
        v-model="checked"
        class="transfer"
        filterable
        :filter-method="filter"
        filter-placeholder="Давайте поищем.."
        :data="listContragents"
        :titles="['Контрагенты', 'Выбранные']"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addContragentToGroup">
          Сохранить
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapGetters } from 'vuex'

const ContragentAPI = RepositoryFactory.get('contragents')
const ContragentGroupAPI = RepositoryFactory.get('contragentsGroup')

export default {
  name: 'EditGroup',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    group: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      checked: [],
      loaded: false,
    }
  },
  computed: {
    listContragents() {
      let array = []

      this.getContragents.map(contragent => {
        array = [
          ...array,
          {
            label: contragent.org_name,
            key: contragent.id,
            initial: false,
          },
        ]
      })

      return array
    },
    ...mapGetters(['getContragents']),
  },
  async mounted() {
    await this.$store.dispatch('fetchContragents').then(() => {
      ContragentAPI.getByGroup(this.group.id).then(response => {
        this.checked = response.data.items.map(response => response.id)
        this.loaded = true
      })
    })
  },
  methods: {
    filter(query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
    },
    async addContragentToGroup() {
      const checkedContragentes = this.checked
      let arrContragents = []

      checkedContragentes.forEach(checkedContragent => {
        const item = this.getContragents.filter(
          contragent => contragent.id == String(checkedContragent),
        )[0]
        const { id } = item

        arrContragents = [...arrContragents, { id }]
      })
      await ContragentGroupAPI.put(this.group.id, {
        members: arrContragents,
      }).then(() => this.closeDialog())
    },
    closeDialog() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped></style>
